export const UNKNOWN = 'Unknown';
export const DRAFT = 'Draft';
export const BOOKED = 'Booked';
export const ALLOCATED = 'Allocated';
export const NOT_ALLOCATED = 'Not allocated';
export const PRE_ALLOCATED = 'Pre allocated';
export const STOP1_PRE_DELAY = 'Stop 1 delay warning';
export const STOP1_DELAY = 'Stop 1 delay';
export const STOP1_ARRIVED = 'Stop 1 arrived';
export const STOP1_DEPARTED = 'Stop 1 departed';
export const STOP2_PRE_DELAY = 'Stop 2 delay warning';
export const STOP2_DELAY = 'Stop 2 delay';
export const STOP2_ARRIVED = 'Stop 2 arrived';
export const STOP2_DEPARTED = 'Stop 2 departed';
export const STOP2_SPLIT = 'Stop 2 split to base';
export const STOP2_SPLIT_WARN = 'Stop 2 split to base warning';
export const COMPLETED = 'Completed';
export const CANCELED = 'Canceled';
export const FUTILE = 'Futile';
